/** 
*@author: satyamurthy.a
*@Description : 
**/
import { connect } from "react-redux";
import ListView from "../../../Utils/ListView";
import Highlighter from "react-highlight-words";
import { encode as base64_encode } from "base-64";
import { constant } from "../../../Utils/constants";
import { API_DEVICE } from "../../../../../commons/api";
import React, { useState, useEffect, useRef } from "react";
import translation from "../../../../../commons/translation";
import {
  Input,
  Tooltip,
  message,
  Button
} from "antd";
import {
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import {
  deleteEquipmentMaster,
  getUsersList,
  getMasterList,
} from "../../../Utils/FormCalls";

const urlList = {
  list: API_DEVICE.LIST,
  delete: API_DEVICE.DELETE,
};

const EquipmentList = (props) => {
  const { translationCache, navigate } = props;

  const [dataSource, setDataSource] = useState([]);
  const [userList, setUserList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);

  const config = {
    title: translation(translationCache, constant.EQUIPMENT_MASTER),
    viewTypes: ['add', 'card', 'table'],
    defaultViewType: 'table',
    filterType: 'ByAttributeValue',
    attributeList: ['DeviceCode'],
    attributeListTitle: ['Equipment Code'],
    firstTitle: 'DeviceCode',
    secondTitle: 'CreatedBy',
    thirdTitle: 'CreatedTime',
    actions: ['edit', 'delete'],
    edit: {
      byAttribute: 'Id',
      redirectURL: '/rubus/AMM/EquipmentDetails'
    },
    deletee: {
      byAttribute: 'Id'
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const dataSource = await getMasterList(urlList.list);
      setDataSource(dataSource);
      const users = await getUsersList();
      setUserList(users);
    };
    fetchData();
  }, []);

  const _editRecord = (record) => {
    navigate({ pathname: `${config.edit.redirectURL}/${base64_encode(record.Id)}` });
  };

  // const _getUserList = async () => {
  //   const userList = await getUsersList();
  //   setUserList(userList);
  // };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(translationCache, 'Search')}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(translationCache, constant.search)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(translationCache, constant.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const _deleteById = async (id) => {
    const deleteResp = await deleteEquipmentMaster(urlList.delete, id);
    if (deleteResp && deleteResp.message) {
      message.success(deleteResp.message);
      const dataSource = await getMasterList(urlList.list);
      setDataSource(dataSource);
    }
  };

  const columns = [
    {
      title: translation(translationCache, constant.equipment),
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      filter: true,
      ...getColumnSearchProps('DisplayCode')
    },
    {
      title: translation(translationCache, constant.equipmentDescription),
      dataIndex: 'Name',
      key: 'Name',
      filter: true,
      ...getColumnSearchProps('Name')
    },
    {
      title: translation(translationCache, constant.location),
      dataIndex: 'AssetDisplayCode',
      key: 'AssetDisplayCode'
    },
    {
      title: translation(translationCache, constant.locationDescription),
      dataIndex: 'AssetDescription',
      key: 'AssetDescription',
      filter: true
    },
    {
      title: translation(translationCache, constant.equipmentCategory),
      dataIndex: 'DeviceType',
      key: 'DeviceType',
      filter: true,
      ...getColumnSearchProps('DeviceType')
    },
    {
      title: translation(translationCache, constant.equipmentCategoryDescription),
      dataIndex: 'DeviceTypeDescription',
      key: 'DeviceTypeDescription',
      filter: true
    },
    {
      title: translation(translationCache, constant.action),
      width: '600',
      render: (text, record) => (
        <>
          <Button
            disabled={record.Status === 'Inactive'}
            onClick={() => _editRecord(record)}
          >
            <Tooltip title={translation(translationCache, constant.Edit)}>
              <EditOutlined />
            </Tooltip>
          </Button>
        </>
      )
    }
  ];



  return (
    <>
      <ListView
        {...props}
        columns={columns}
        dataSource={dataSource}
        userList={userList}
        config={config}
        delete={_deleteById}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache,
  userProfile: state.LayoutReducer.userProfile,
});

export default connect(mapStateToProps)(EquipmentList);